export { default } from './HighlightedText';
